export default [
  {path: '/brandNewsInfo/:id/:keyWord/:html', name: '品牌详情', component: () => import('@/view/brandNewsInfo/brandNewsInfo'), meta: {title: '品牌详情', }, },
  {path: '/brandInfo/:html', name: '品牌资讯', component: () => import('@/view/brandInfo/brandInfo'), meta: {title: '品牌资讯', }, },
  {path: '/weightLossInfo/:html', name: '减肥知识', component: () => import('@/view/weightLossInfo/weightLossInfo'), meta: {title: '减肥知识', }, },
  {path: '/caseSharing/:html', name: '案例分享', component: () => import('@/view/caseSharing/caseSharing'), meta: {title: '案例分享', }, },
  {path: '/InformationList/:html', name: 'InformationList', component: () => import('@/view/InformationList/InformationList'), meta: {title: '减肥知识', }, },
  {path: '/keyWordlist/:key/:page/:html', name: 'keyWordlist', component: () => import('@/view/keyWordlist/keyWordlist'), meta: {title: '关键字', }, }, // 关键字列表页
];



// WEBPACK FOOTER //
// src/router/News.js